import Vue from 'vue';
import Router from 'vue-router';
import { RoutePaths } from '@/constants/RoutePaths';
import { RouteNames } from '@/constants/RouteNames';
import Login from '@/views/UnAuth/Login.vue';
import ForgotPassword from '@/views/UnAuth/ForgotPassword.vue';
import ResetPassword from '@/views/UnAuth/ResetPassword.vue';
import Register from '@/views/UnAuth/Register.vue';
import Dashboard from '@/views/Auth/Dashboard.vue';
import UpdateNaw from '@/views/Auth/UpdateNaw.vue';
import store from './store';
import { GetterNames } from '@/constants/GetterNames';

interface Meta {
  meta: {
    needsAuth: boolean,
  };
}

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: 'login',
    },
    {
      path: RoutePaths.RESET_PASSWORD,
      name: RouteNames.RESET_PASSWORD,
      component: ResetPassword,
      meta: {
        needsAuth: false,
      },
    },
    {
      path: RoutePaths.LOGIN,
      name: RouteNames.LOGIN,
      component: Login,
      meta: {
        needsAuth: false,
      },
    },
    {
      path: RoutePaths.REGISTER,
      name: RouteNames.REGISTER,
      component: Register,
      meta: {
        needsAuth: false,
      },
    },
    {
      path: RoutePaths.FORGOT_PASSWORD,
      name: RouteNames.FORGOT_PASSWORD,
      component: ForgotPassword,
      meta: {
        needsAuth: false,
      },
    },
    {
      path: RoutePaths.DASHBOARD,
      name: RouteNames.DASHBOARD,
      component: Dashboard,
      meta: {
        needsAuth: true,
      },
    },
    {
      path: RoutePaths.CHANGE_NAW,
      name: RouteNames.CHANGE_NAW,
      component: UpdateNaw,
      meta: {
        needsAuth: true,
      },
    },
  ],
});

router.beforeEach((to: Meta | any, from: any, next: any) => {
  const isLoggedIn: boolean = store.getters[GetterNames.IS_LOGGED_IN];

  if (to.meta.needsAuth) {
    if (!isLoggedIn) {
      router.push({
        name: RouteNames.LOGIN,
      });
    } else {
      next();
    }
  } else {
    if (!isLoggedIn) {
      next();
    } else {
      router.push({
        name: RouteNames.DASHBOARD,
      });
    }
  }
});

export default router;
